import { useState } from "react"
import { KeyedMutator } from "swr"

import {
    SUPPORT_REFER,
    SUPPORT_REFER_HELP_DESK,
} from "../../../../errors/errorMessages"
import { parseErrorAsObj } from "../../../../errors/errorProcessors"
import { snackbar } from "../../../../utils/general/generalUtils"
import { patchClientProtected } from "../../clients/clients"
import { TUsersOutput } from "../../mappers/adminPortal/activeUsersMapper"
import { ADD_TO_GROUP } from "../../urls/private"

export const MUST_LOG_OUT_AND_IN =
    "They must log out and back in for this change to take effect"

type IAddGroup = {
    addGroup: (
        group: string,
        resetSwitchOnFail?: () => void,
        isApproving?: boolean
    ) => Promise<void>
    isLoading: boolean
}

const useAddGroup = (
    userName: string,
    fullName: string,
    mutate: KeyedMutator<TUsersOutput>
): IAddGroup => {
    const [isLoading, setIsLoading] = useState(false)
    const addGroup = async (
        group: string,
        resetSwitchOnFail?: () => void,
        isApproving = false
    ): Promise<void> => {
        try {
            setIsLoading(true)
            await patchClientProtected(ADD_TO_GROUP(userName, group), null)
            const msg = isApproving
                ? `${fullName} successfully approved. ${MUST_LOG_OUT_AND_IN}`
                : `${fullName} successfully granted this role. ${MUST_LOG_OUT_AND_IN}`
            snackbar(msg, "success")
            mutate()
        } catch (err) {
            const errorObj = parseErrorAsObj(err)
            if (resetSwitchOnFail) {
                resetSwitchOnFail()
            }

            let errorMsg
            if (errorObj?.code === 403) {
                errorMsg = `${errorObj?.message}. Please ${SUPPORT_REFER_HELP_DESK}`
            } else {
                errorMsg = isApproving
                    ? `Unable to approve ${fullName}. Please try again. ${SUPPORT_REFER}`
                    : `Unable to grant ${fullName} this role . Please try again. ${SUPPORT_REFER}`
            }

            snackbar(errorMsg, "warning")
        } finally {
            setIsLoading(false)
        }
    }

    return {
        addGroup,
        isLoading,
    }
}

export default useAddGroup
